// Client-side: one /api/geo request per page load, shared by every caller (utils/countryDetection.ts for the
// currency country, lib/pricing/story-page-counts-client.ts for the offered story lengths).
// Resolves to the parsed body, or null on a network failure / non-ok response. A null result is not kept,
// so a later call retries, as each caller did before the request was shared.

export type ClientGeo = { country?: unknown; [key: string]: unknown };

let inflight: Promise<ClientGeo | null> | null = null;

export function fetchClientGeo(fetchFn: typeof fetch = fetch): Promise<ClientGeo | null> {
  if (!inflight) {
    const p: Promise<ClientGeo | null> = fetchFn('/api/geo', { cache: 'no-store' })
      .then((r) => (r.ok ? r.json() : null))
      .catch(() => null)
      .then((geo) => {
        if (!geo && inflight === p) inflight = null;
        return geo ?? null;
      });
    inflight = p;
  }
  return inflight;
}

export function __resetClientGeoForTests() {
  inflight = null;
}
